import React, { Component } from "react";
import ChatIcon from "../images/chat.png";
import "../styles/scss/chat.scss"; // Import the SCSS stylesheet for styling

export default class Chatbot extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.toggleChat = this.toggleChat.bind(this);
  }

  toggleChat() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    const { isOpen } = this.state;

    return (
      <div>
        {/* Open Chat Button */}
        {!isOpen && (
          <button className="chatbot-button" onClick={this.toggleChat}>
            <img src={ChatIcon} alt="Chat" width={28} height={28} />
          </button>
        )}

        {/* Chat iframe with close button */}
        {isOpen && (
          <div className="chatbot-container">
            <button className="chatbot-close" onClick={this.toggleChat}>
              &#10005;
            </button>
            <iframe
              //src={`https://d1w8dbtoq44f0.cloudfront.net/?t=${Date.now()}`}
              src="https://lucky1-chatbot-stg.s3.ap-south-1.amazonaws.com/index.html"
              title="Chatbot"
              scrolling="no"
              className="chatbot-iframe"
            />
          </div>
        )}
      </div>
    );
  }
}
